module.exports = __webpack_public_path__ + "img/1.821e4b80.png";